import React from 'react';
import { Route } from 'react-router-dom';
import { PublicLayout } from '../layouts/PublicLayout';
import { CreateQuotePage } from '../pages/public/CreateQuotePage';
import { QuoteSuccessPage } from '../pages/public/QuoteSuccessPage';
import { LoginPage } from '../pages/public/LoginPage';
import { ForgotPasswordPage } from '../pages/public/ForgotPasswordPage';
import { ResetPasswordPage } from '../pages/public/ResetPasswordPage';
import { RegistrationPage } from '../pages/public/RegistrationPage';
import { LegalDocumentPage, LegalDocumentRedirect } from '../pages/public/LegalDocumentPage';

export const publicRoutes = (
  <>
    <Route element={<PublicLayout />}>
      <Route path="/" element={<CreateQuotePage />} />
      <Route path="/success" element={<QuoteSuccessPage />} />
      <Route path="/login" element={<LoginPage />} />
      <Route path="/forgot-password" element={<ForgotPasswordPage />} />
      <Route path="/reset-password" element={<ResetPasswordPage />} />
      <Route path="/register" element={<RegistrationPage />} />
    </Route>

    {/*
     * Legal documents own the page `h1` and start their body at `h2`, so they
     * mount the public shell without the marketing hero to keep heading order
     * correct. The header and footer (with the locale-aware legal cross-links)
     * are unchanged.
     */}
    <Route element={<PublicLayout showHero={false} />}>
      <Route path="/pt/termos" element={<LegalDocumentPage kind="terms" documentLocale="pt" />} />
      <Route path="/pt/privacidade" element={<LegalDocumentPage kind="privacy" documentLocale="pt" />} />
      <Route path="/en/terms" element={<LegalDocumentPage kind="terms" documentLocale="en" />} />
      <Route path="/en/privacy" element={<LegalDocumentPage kind="privacy" documentLocale="en" />} />
      <Route path="/termos" element={<LegalDocumentRedirect kind="terms" />} />
      <Route path="/privacidade" element={<LegalDocumentRedirect kind="privacy" />} />
      <Route path="/terms" element={<LegalDocumentRedirect kind="terms" />} />
      <Route path="/privacy" element={<LegalDocumentRedirect kind="privacy" />} />
    </Route>
  </>
);
